import { MeasurementSystem } from '@fleet-bffs/api-contract';
import { createAction } from '@reduxjs/toolkit';
import type { ErrorType } from '~/data/ErrorRecord';
import { createRequestAction } from '~/utils/create-action/create-action';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';
import { LogoutStatus } from '~/domain/auth/models/LogoutStatus';
import type { CurrentUserInfo } from './data/AuthenticationState';

const prefix = getCurrentDirname(__dirname);

export const setTokenAndProvider = createAction<{
  token: string | undefined;
  provider: string | undefined;
  expiresAt: number | undefined;
  refreshToken: string | undefined;
}>(`${prefix}/SET_TOKEN_AND_PROVIDER`);

export const setAuthenticated = createAction<{
  status: boolean;
}>(`${prefix}/SET_AUTHENTICATED`);

export const setMeasurementSystem = createAction<{
  measurementSystem: MeasurementSystem;
}>(`${prefix}/SET_MEASUREMENT_SYSTEM`);

export const loginUser = createAction<{
  username: string;
  password: string;
}>(`${prefix}/LOGIN`);

export const loginDIAM = createRequestAction<{
  username: string;
  password: string;
}>(`${prefix}/LOGIN_DIAM`);

export const refreshUser = createAction<{
  token: string;
}>(`${prefix}/REFRESH`);

export const refreshDIAM = createRequestAction<{
  token: string;
}>(`${prefix}/REFRESH_DIAM`);

export const displayError = createAction<{ error: ErrorType }>(`${prefix}/DISPLAY_ERROR`);

export const fetchUserInfoFromFleet = createRequestAction(`${prefix}/FETCH_USER_INFO_FLEET`);

export const patchUserName = createAction<{
  name: string;
}>(`${prefix}/PATCH_USER_NAME_AND_LOCALE`);

export const logoutUser = createAction(`${prefix}/LOGOUT_USER`);

export const clearUser = createAction(`${prefix}/CLEAR_USER`);

export const populateAuthentication = createAction<CurrentUserInfo>(
  `${prefix}/POPULATE_AUTHENTICATION`
);

export const setExpiresAt = createAction<{ expiresAt: number }>(`${prefix}/SET_EXPIRES_AT`);

export const setLogoutStatus = createAction<LogoutStatus>(`${prefix}/SET_LOGOUT_STATUS`);
